import { render } from "./LinksView.vue?vue&type=template&id=2ae644d7&scoped=true"
import script from "./LinksView.vue?vue&type=script&lang=js"
export * from "./LinksView.vue?vue&type=script&lang=js"

import "./LinksView.vue?vue&type=style&index=0&id=2ae644d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ae644d7"

export default script